import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown-box" }
const _hoisted_2 = { class: "dropdown-box__label" }

import DropdownStandard, { optionType } from '@/design-system/molecules/DropdownStandard.vue'
import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { COCLASS, COCLASSGROUPS } from '@/interfaces/coclass.interface'

interface Props {
  roomTypes: COCLASS[]
  selectedRoomTypes: COCLASS[]
  optionsWithData?: Set<string | null>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardDropdownFilterRoomType',
  props: {
    roomTypes: {},
    selectedRoomTypes: {},
    optionsWithData: {}
  },
  emits: ["selectionChanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const { selectedRoomTypes } = toRefs(props)

const { t, locale } = useI18n()
const label = t('general__text__roomtypes')

const groupedCoClasses: { [roomGroup: string]: COCLASS[] } = {}
props.roomTypes.forEach((x) => {
  groupedCoClasses[x.roomGroup]
    ? groupedCoClasses[x.roomGroup].push(x)
    : (groupedCoClasses[x.roomGroup] = [x])
})

const searchType = computed<string>(() => {
  return t('general__text__room-type').toLowerCase()
})

const title = computed<string>(() => {
  const selectedOptionCount = options.value.filter((x) => x.selected).length
  if (selectedOptionCount === options.value.length) {
    return t('general__text__all-roomtypes')
  }
  if (selectedOptionCount > 1) {
    return [
      selectedOptionCount,
      t('general__text__room-types').toLowerCase(),
      t('general__text__chosen').toLowerCase()
    ].join(' ')
  }
  if (selectedOptionCount === 1) {
    const selection = options.value.find((x) => x.selected)
    return selection?.name ?? ''
  }
  if (selectedOptionCount === 0) {
    return t('general__data__select-room-types')
  }
  return ''
})

const allSelected = computed<boolean>(() => {
  const allButFirst = options.value.slice(1)
  const enabledCount = allButFirst.filter((x) => !x.disabled).length
  const selectedCount = allButFirst.filter((x) => x.selected).length
  return enabledCount === selectedCount
})

const options = computed<optionType[]>(() => {
  const options: optionType[] = []
  for (let [roomGroup, coclasses] of Object.entries(groupedCoClasses)) {
    const selected = selectedRoomTypes.value.map((y) => y.roomGroup).includes(roomGroup)
    const disabled = !selected && shouldBeDisabled(coclasses)
    const subtitle =
      selected && shouldBeDisabled(coclasses) ? t('general__data__data-missing') : undefined
    options.push({
      id: roomGroup,
      name: COCLASSGROUPS[roomGroup] ? COCLASSGROUPS[roomGroup][locale.value] : roomGroup,
      value: coclasses,
      disabled,
      selected,
      subtitle
    })
  }
  options.sort((a, b) => {
    if (a.disabled === b.disabled) {
      if (a.name === b.name) {
        return 0
      }
      return a.name < b.name ? -1 : 1
    }
    return a.disabled < b.disabled ? -1 : 1
  })

  return options
})

function shouldBeDisabled(coclasses: COCLASS[]): boolean {
  if (props.optionsWithData === undefined) return false

  const anyCoclassHasData = coclasses.some((coclass) => props.optionsWithData?.has(coclass.coclass))
  return !anyCoclassHasData
}

function select(id: string) {
  if (id === 'roomTypes_all') {
    emits('selectionChanged', [])
    return
  }

  const selections: { [roomGroup: string]: COCLASS[] } = {}
  selectedRoomTypes.value.forEach((x) => {
    selections[x.roomGroup] ? selections[x.roomGroup].push(x) : (selections[x.roomGroup] = [x])
  })

  const selectedOption = options.value.find((x) => x.id === id)
  if (selectedOption && !selections[selectedOption.id]) {
    const coclasses = Object.values(selections).flat()
    emits('selectionChanged', [...coclasses, ...(selectedOption.value ?? [])])
  } else if (selectedOption) {
    delete selections[selectedOption.id]
    const coclasses = Object.values(selections).flat()
    emits('selectionChanged', [...coclasses])
  }
}

function selectAll() {
  if (!allSelected.value) {
    const enabled = options.value.filter((x) => !x.disabled)
    const updated = enabled.map((x) => ({ ...x, selected: true }))
    const coclasses = updated.map((x) => x.value).flat()
    emits('selectionChanged', coclasses)
  } else {
    emits('selectionChanged', [])
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(label)), 1),
    _createVNode(DropdownStandard, {
      options: options.value,
      searchType: searchType.value,
      title: title.value,
      multiSelect: true,
      isAllSelected: allSelected.value,
      hasSearch: true,
      onSelect: select,
      onSelectAll: selectAll
    }, null, 8, ["options", "searchType", "title", "isAllSelected"])
  ]))
}
}

})